import controller from './consult-crm.controller';
import template from './consult-crm.view.html';

let ConsultCrmComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default ConsultCrmComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/consult-crm/consult-crm.component.js
 **/